import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependecy'
import { TemplateNavHeaderStyles } from './NavHeader-Level2.styles'

const t = document.createElement('template')
t.innerHTML = `
  <!-- TODO: class needed for "menu-open" -->
  <header class="ascend-header ascend-header-level2 header-inner" role="banner">
    <!-- Top Header: -->
    <nav class="main-nav" role="navigation" aria-label="Main Navigation">
      <!-- logo -->
      <slot name="logo"></slot>
      <!-- Site action & profile menu -->
      <slot name="utilityNavigation"></slot>
    </nav>
    <div class="mobile-header">
        <slot name="sectionTitle"></slot>
        <slot name="mobilecontextualNavigation"></slot> 
    </div>

    <slot name="primaryNavigationMobile"></slot>
    <div class="tab-header">
      <slot name="contextualNavigation"></slot> 
    </div>
  </header>
`
const TemplateNavHeader = t

class NavHeader extends HTMLElement {
  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Tree, WebAwesomeComponent.TreeItem])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(TemplateNavHeaderStyles.content.cloneNode(true))
    shadow.appendChild(TemplateNavHeader.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavigationSiteHeader connectedCallback')
    this.addEventListener('toggle-hamburger', (event) => {
      console.log('toggle-hamburger event received from NavHeader', event)

      const navMobileComponents =
        this.shadowRoot?.ownerDocument?.getElementsByTagName('ts-navheader-mobile')
      if (navMobileComponents && navMobileComponents.length > 0) {
        const navMobile = navMobileComponents[0]
        if (navMobile) {
          const isOpen = navMobile.getAttribute('isopen') === 'true'
          navMobile.setAttribute('isopen', (!isOpen).toString())
        }
      }

      const navMobilePanel = this.shadowRoot?.getElementById('nav-mobile-panel')
      if (navMobilePanel) {
        navMobilePanel.classList.toggle('open')

        if (navMobilePanel.classList.contains('open')) {
          navMobilePanel.classList.remove('closed')
          navMobilePanel.classList.add('open')
        } else {
          navMobilePanel.classList.add('closed')
          navMobilePanel.classList.remove('open')
        }
      }
    })
  }
}
customElements.define('ts-navheader-level2', NavHeader)
